<template>
    <div>
        <!-- User Interface controls -->
        <b-row>
            <b-col md="7" class="my-1">
                <b-form-group class="mb-0">
                    <b-input-group>
                        <b-form-input v-model="filter" placeholder="Type to Search" />
                        <b-input-group-append>
                            <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col md="5" class="my-1">
                <b-form-group label-cols="4" label="Per page" class="mb-0">
                    <b-form-select :options="pageOptions" v-model="perPage" />
                </b-form-group>
            </b-col>
        </b-row>

        <!-- Main table element -->
        <b-table empty-text="Please wait while the evaluations load." striped responsive stacked="md" :items="items"
            :fields="fields" :filter="filter" :current-page="currentPage" :per-page="perPage" :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc" @filtered="onFiltered">
          <template v-slot:cell(year)="row">
            <div v-if="!row.item.year">
              <div>Year: {{ row.item.year }}</div>
              <b-form-select label="Year" v-model="row.item.selected">
                <option>{{ moment().add(2, 'year').year() }}</option>
                <option>{{ moment().add(1, 'year').year() }}</option>
                <option>{{ moment().year() }}</option>
                <option>{{ moment().subtract(1, 'year').year() }}</option>
                <option>{{ moment().subtract(2, 'year').year() }}</option>
              </b-form-select>
              <b-button
                  @click="changeYear(row.item.id, row.item.selected)"
                  class="btn btn-primary"
              >
                <span class="icon icon-shareable"></span>
              </b-button>
            </div>
            <div v-else>
              {{ row.item.year }}
            </div>
          </template>
            <template v-slot:cell(actions)="row" class="text-nowrap">
                <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                <b-button-group>
                    <b-button @click="viewStudent(row.item.id)" class="btn btn-success">
                        <span class="icon icon-eye">
                            View Clinical Evaluations</span>
                    </b-button>
                    <b-dropdown variant="primary" right text="Actions">
                        <b-dropdown-item @click.stop="editUser(row.item.id)">Edit</b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item @click.stop="info(row.item.name, row.item.id, $event.target)">Delete User
                        </b-dropdown-item>
                      <b-dropdown-divider></b-dropdown-divider>
                      <b-dropdown-item v-if="row.item.year" @click.stop="deleteYear(row.item.year)">Delete All Users from {{ row.item.year }}
                      </b-dropdown-item>
                    </b-dropdown>
                </b-button-group>
            </template>
        </b-table>
        <!-- Info modal -->
    <b-modal ok-title="Yes Delete" cancel-title="Cancel" ok-variant="danger" cancel-variant="primary" id="modalInfo"
      @hide="resetModal" @ok="deleteUser" :title="modalInfo.title">
      <h4>{{ modalInfo.content }}</h4>
    </b-modal>
        <b-row>
            <b-col md="12" class="my-1">
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
            </b-col>
        </b-row>
    </div>
</template>

<script>
	const items = [];
	var moment = require('moment');
	export default {
	    props: ['students'],
	    data() {
	        return {
	            items: this.students,
	            url: this.url,
	            moment: moment,
	            fields: [{
	                    key: "name",
	                    label: "Student"
	                },
                {
                  key: "year",
                  label: "Year"
                },
	                {
	                    key: "actions",
	                    label: "Actions"
	                }
	            ],
	            filter: null,
	            sortBy: "name",
	            sortDesc: false,
	            currentPage: 1,
	            perPage: 25,
	            totalRows: this.students.length,
	            pageOptions: [15, 25, 35, 50],
	            modalInfo: {
	                title: '',
	                content: '',
	                id: ''
	            }
	        };
	    },
	    computed: {
	        sortOptions() {
	            // Create an options list from our fields
	            return this.fields.filter(f => f.sortable).map(f => {
	                return {
	                    text: f.label,
	                    value: f.key
	                };
	            });
	        }
	    },
	    methods: {
	        onFiltered(filteredItems) {
	            // Trigger pagination to update the number of buttons/pages due to filtering
	            this.totalRows = filteredItems.length;
	            this.currentPage = 1;
	        },
	        viewStudent(id) {
	            window.location.href = '/school/student/competencies/' + id;
	        },
	        info(name, id, button) {
	            this.modalInfo.title = `Are you sure you want to delete this student?`
	            this.modalInfo.content = 'All of the evaluations for ' + name + ' will be deleted!'
	            this.modalInfo.id = id
	            this.$root.$emit('bv::show::modal', 'modalInfo', button)
	        },
	        resetModal() {
	            this.modalInfo.title = ''
	            this.modalInfo.content = ''
	            this.modalInfo.id = ''
	        },
        changeYear(user, year) {
          axios
              .post('/school/user/archive-year', {
                user_id: user,
                year: year
              })
              .then(response => (this.items = response.data))
              .catch(function (error) {
                // handle error
                console.log(error);
              });
        },
        deleteYear(year) {
          Swal.fire({
            title: 'Are you sure?',
            text: "This will delete every student from that year!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete them!'
          }).then((result) => {
            if (result.isConfirmed) {
              axios.delete('/school/user/year-delete/' + year)
                  .then(response => this.items = response.data)
                  .catch(function (error) {
                    // handle error
                    Swal.fire({
                      title: 'Oops',
                      text: "Something went wrong, please contact support.",
                      icon: 'warning'
                    })
                    console.log(error);
                  });
            }
          });
        },
	        deleteUser(id) {
	            this.modalInfo.title = ''
	            this.modalInfo.content = ''
	            axios.get('/school/user/archived/delete/' + this.modalInfo.id)
	                .then(response => this.items = response.data)
	                .catch(function (error) {
	                    // handle error
	                    console.log(error);
	                });
	            swal({
	                title: "User Deleted!",
	                icon: "success"
	            });
	        },
	        editUser(id) {
	            window.location.href = '/school/user/edit/' + id;
	        },
	    },
	};
</script>

<!-- table-complete-1.vue -->